import merge from 'lodash/merge'

export default {
  setOrgWidget({
    commit
  }, obj) {
    commit('setOrgId', obj.orgId)
    commit('setWidgetId', obj.widgetId)
  },
  storeCache({
    commit
  }, msgs) {

    let cache = []

    if (msgs.length)
      for (let i = 0; i < msgs.length; i++)
        cache.push({
          'template': msgs[i].template,
          'msgLength': msgs[i].message ? msgs[i].message.length : 0,
          'operator': msgs[i].operator,
          'tail': msgs[i].tail,
          'from': msgs[i].from,
          'read': msgs[i].read,
          'created_at': msgs[i].created_at,
          'media': msgs[i].media ? { type: msgs[i].media.type } : 0,
          'meta': msgs[i].meta
        })

    commit('setCache', cache)

  },
  toggleMinimize({
    getters,
    commit,
  }) {


    commit('setMinimize', !getters.isMinimize)
    if (!getters.isMinimize && getters.isHidden)
      commit('setHidden', false)

  },
  setHidden({
    getters,
    commit,
  }, value) {

    commit('setHidden', !!value)

  },
  updateTempLang({ commit }, { label, value }) {
    if (label && value)
      commit('setTempLang', { label, value })
  },
  updateHeader({ commit }, { when, label, value }) {
    if (when && label && value)
      commit('setTempHeader', { when, label, value })
  },
}
